import { render, staticRenderFns } from "./carViolationRecordList.vue?vue&type=template&id=ab3d08a8&scoped=true"
import script from "./carViolationRecordList.vue?vue&type=script&lang=js"
export * from "./carViolationRecordList.vue?vue&type=script&lang=js"
import style0 from "./carViolationRecordList.vue?vue&type=style&index=0&id=ab3d08a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab3d08a8",
  null
  
)

export default component.exports